import React, { useMemo } from 'react';
import { axisTooltipFormatter } from '@common/utils/chartTooltipFormatter';
import { truncateLabel } from '@common/utils/chartUtils';
import ChartWidgetContainer from '@common/components/ChartWidgetContainer';

function StackedLineChartWidget({ widget }) {
  const { data } = widget;

  const option = useMemo(() => {
    if (!data || !data.series) return null;

    return {
      tooltip: {
        trigger: 'axis',
        confine: true,
        appendToBody: true,
        formatter: axisTooltipFormatter,
      },
      legend: {
        data: data.series.map(s => s.name),
        textStyle: {
          fontSize: 11,
        },
        formatter: (name) => truncateLabel(name),
        tooltip: {
          show: true,
          formatter: (params) => params.name,
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: data.categories || [],
        axisLabel: {
          fontSize: 11,
          formatter: (value) => truncateLabel(value),
        },
        tooltip: {
          show: true,
          formatter: (params) => params.value,
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 11,
          formatter: (value) => truncateLabel(value),
        },
        tooltip: {
          show: true,
          formatter: (params) => params.value,
        },
      },
      series: data.series.map((series, index) => ({
        name: series.name,
        type: 'line',
        stack: 'total',
        data: series.data,
        itemStyle: {
          color: series.color || `hsl(${index * 60}, 70%, 50%)`,
        },
        lineStyle: {
          color: series.color || `hsl(${index * 60}, 70%, 50%)`,
        },
        areaStyle: {
          color: series.color ? `${series.color}66` : `hsl(${index * 60}, 70%, 50%)66`,
        },
        smooth: true,
      })),
    };
  }, [data]);

  return <ChartWidgetContainer widget={widget} option={option} />;
}

export default StackedLineChartWidget;
